import { P2Footer } from 'react-bootstrap-common-script'
import OldFooter from './old-footer'

function Footer() {
  return (
    <>
      {/* <P2Footer/> */}
      <OldFooter/>
    </>
  )
}

export default Footer
